import EmptyState from '@app/src/components/EmptyState'
import Avatar from '@app/src/components/Ui/Avatar'
import { useAuthentication } from '@app/src/context/AuthenticationContext'
import useOrganizationSettings from '@app/src/hooks/useOrganizationSettings'
import { isAdminRole } from '@app/src/utils/rolePermissions'
import type { SvgIconComponent } from '@mui/icons-material'
import { AutoAwesomeOutlined, BusinessOutlined, LinkRounded, TravelExploreOutlined } from '@mui/icons-material'
import { Button, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const steps: { key: string; icon: SvgIconComponent }[] = [
  { key: 'choose', icon: BusinessOutlined },
  { key: 'search', icon: TravelExploreOutlined },
  { key: 'review', icon: LinkRounded },
]

const AiScreeningEmptyState: React.FC = () => {
  const { formatMessage } = useIntl()
  const { role } = useAuthentication().scope
  const { updateOrganizationSettings, isSaving } = useOrganizationSettings()
  const isAdmin = isAdminRole(role)

  return (
    <Stack bgcolor="background.paper" borderRadius={2} p={4}>
      <EmptyState
        iconComponent={AutoAwesomeOutlined}
        title={formatMessage({ id: 'aiScreening.emptyState.title' })}
        description={formatMessage({ id: 'aiScreening.emptyState.description' })}
      >
        <Stack spacing={4} alignItems="center">
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} maxWidth={960}>
            {steps.map(({ key, icon: Icon }) => (
              <Stack key={key} spacing={1.5} flex={1} bgcolor="grey.100" borderRadius={2} p={2.5}>
                <Avatar sx={({ palette }) => ({ bgcolor: palette.secondary.main })}>
                  <Icon />
                </Avatar>
                <Typography variant="subtitle1">
                  {formatMessage({ id: `aiScreening.emptyState.steps.${key}.title` })}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {formatMessage({ id: `aiScreening.emptyState.steps.${key}.description` })}
                </Typography>
              </Stack>
            ))}
          </Stack>
          <Typography variant="body2" color="text.secondary" align="center">
            {formatMessage({ id: 'aiScreening.creditsOverview.oneCreditDescription' })}
          </Typography>
          {isAdmin && (
            <Button
              variant="contained"
              disabled={isSaving}
              onClick={() => updateOrganizationSettings({ aiScreeningEnabled: true })}
            >
              {formatMessage({ id: 'aiScreening.emptyState.turnOn' })}
            </Button>
          )}
        </Stack>
      </EmptyState>
    </Stack>
  )
}

export default AiScreeningEmptyState
